<template>
  <v-container fluid>
    <!-- <v-container> -->
    <!-- <v-card-title> -->
    <!-- Airbox -->
    <v-spacer></v-spacer>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <!-- </v-card-title> -->
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      dense
      :loading="loading"
      loading-text="Loading... Please wait"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.FlagUrl="{ item }">
        <v-avatar size="24" right
                      ><img :src="item.FlagUrl"
                    /></v-avatar>
      </template>
      <template v-slot:item.HappId="{ item }">
        <v-chip
                      color="primary"
                      dark
                      min-width="300"
                      rounded
                      small
                      :to="{ name: 'EventDetail', params: { id: item.HappId } }"
                      >Details
                      <v-icon right small>mdi-view-list-outline</v-icon></v-chip
                    >
      </template>
    </v-data-table>
    <!-- </div> -->
  </v-container>
</template>

<script>

export default {

  name: 'HappTable',
    props: {
        items: {
            type: Array
        }
    },
  data() {
    return {
      search: "",
      loading: true,
      dialog: false,
      pid: null,
      headers: [
        // { text: "Date", value: "Dato" },
        { text: "N", value: "FlagUrl" },
        { text: "Name", value: "HappName" },
        { text: "Pilots", value: "NumOfPilots" },
        // { text: "Admin", value: "HappOwner" },
        { text: "Start", value: "StartStringDate" },
        { text: "End", value: "EndStringDate" },
        { text: "Location", value: "LocationName" },
        { text: "Details", value: "HappId" },
        // { text: "Id", value: "RegId" }
      ],
      // items: [],
      // errors: []
    };
  },
  created() {
    //
    this.loading = false;
  },
}
//   methods: {
//     getColor(Status) {
//       if (Status === "START") return "red";
//       else if (Status === "LANDED") return "orange";
//       else return "green";
//     },
//     editStatus(pid) {
//       console.log(pid);
//       this.pid = pid;
//       console.log("/airbox/pilotstatus/", pid);
//       this.dialog = true;
//     }
//   }
// };
</script>
